import { useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import { Timestamp } from "firebase/firestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

interface Data {
    content: string;
    id: string;
    register_date: Timestamp;
    student: boolean;
    teacher: boolean;
    title: string;
  }

  interface Notice {
    title: string;
    content: string;
    register_date: Timestamp;
  }

const usePreviewNotice = (teacher:boolean) => {
    const [notices, setNotices] = useState<Notice[]>([]);
    const {getBranchId} = useGetBranchId();
    const {readFirestoreWithSortWithLimit, readFirestore} = useFirestore();

    useEffect(() => {
        if(teacher){
            getTeacherNotice();
        }else{
            getAllNotice();
        }
        // eslint-disable-next-line
    }, [teacher])

    const getAllNotice = () => {
        readFirestoreWithSortWithLimit("Notice/Master/All", {name:"register_date", direction:"desc"}, 3).then(res =>{
            res.forEach((data:any)=> {
                setNotices(prevState => [...prevState, data.data()]);
            })
        })
    }

    const getTeacherNotice = async() => {
      const notice_list:any[] = [];
      const master_notice_list = await readFirestore('Notice/Master/All').then(res => {
          const list:any[] = [];
          const docs = res.docs;
          const docs_length = res.docs.length;
          for(let i = 0; i < docs_length; i++){
              const doc = docs[i];
              list.push({id:doc.id, ...doc.data()})
          }
          return list;
      })
      notice_list.push(...master_notice_list);
      const branch_id = await getBranchId();
      const branch_notice_list = await readFirestore(`Notice/Branch/${branch_id}`).then(res => {
          const list:any[] = [];
          const docs = res.docs;
          const docs_length = res.docs.length;
          for(let i = 0; i < docs_length; i++){
              const doc = docs[i];
              list.push({id:doc.id, ...doc.data()})
          }
          return list;
      })
      console.log(branch_notice_list);
      notice_list.push(...branch_notice_list);
      const sorted_notice: Notice[] = getTopThreeNotices(notice_list);
      setNotices(sorted_notice);
  }


    function sortDataByRegisterDate(dataArray: Data[]): Data[] {
        return dataArray.sort((a, b) => {
          if (a.register_date.seconds !== b.register_date.seconds) {
            return b.register_date.seconds - a.register_date.seconds;
          } else {
            return b.register_date.nanoseconds - a.register_date.nanoseconds;
          }
        });
      }

    function getTopThreeSortedData(dataArray: Data[]): Data[] {
        const sortedData = sortDataByRegisterDate(dataArray);
        return sortedData.slice(0, 3);
      }
      
      function convertToNotice(data: Data): Notice {
        return {
          title: data.title,
          content: data.content,
          register_date: data.register_date
        };
      }
      
    function getTopThreeNotices(dataArray: Data[]): Notice[] {
        const topThreeData = getTopThreeSortedData(dataArray);
        return topThreeData.map(convertToNotice);
      }

    return {notices};
}

export default usePreviewNotice;